import { useQuery } from "urql";
import { graphql } from "../../../../__generated__/gql";
import Card from "../../../../ui/Card/Card";
import Button from "../../../../ui/Button/Button";
import styles from "./PaymentDetailsCard.module.scss";
import { useEffect } from "react";
import { CustomerPortalFlowType } from "../../../../__generated__/gql/graphql";
import { useDisclosure } from "../../../../ui/util/useDisclosure";
import LinkTeamsModal from "./LinkTeamsModal";
import Tooltip from "../../../../ui/Tooltip/Tooltip";
import useUser from "../../../../providers/UserProvider/useUser";

const CustomerPortalQuery = graphql(/* GraphQL */ `
  query customerPortal($flowType: CustomerPortalFlowType) {
    customerPortal(flowType: $flowType) {
      url
    }
  }
`);

function PaymentDetailsCard() {
  const { tenant, userOrganizations } = useUser();

  const isLinkedOrParent = !!(
    tenant?.parentTenant || tenant?.linkedTenants?.length
  );

  const [linkTeamsModalOpened, linkTeamsModal] = useDisclosure();
  const [customerPortalResponse, fetchCustomerPortalQuery] = useQuery({
    query: CustomerPortalQuery,
    pause: true,
  });
  const [paymentMethodUpdateResponse, fetchPaymentMethodUpdateQuery] = useQuery(
    {
      query: CustomerPortalQuery,
      pause: true,
      variables: {
        flowType: CustomerPortalFlowType.PaymentMethodUpdate,
      },
    },
  );

  useEffect(() => {
    const data =
      customerPortalResponse.data ?? paymentMethodUpdateResponse.data;

    if (data?.customerPortal?.url) {
      window.open(data.customerPortal.url, "_blank");
    }
  }, [customerPortalResponse, paymentMethodUpdateResponse]);

  const tooltipContent = `Your billing is managed by ${tenant?.parentTenant?.name}. Changes to be billing must be made from the ${tenant?.parentTenant?.name} team.`;

  return (
    <Card className={styles.card}>
      <p className={styles.title}>Billing options</p>
      {tenant?.parentTenant ? (
        <>
          <Tooltip content={tooltipContent}>
            <Button variant="outline" disabled>
              View billing history
            </Button>
          </Tooltip>
          <Tooltip content={tooltipContent}>
            <Button variant="outline" disabled>
              Edit payment details
            </Button>
          </Tooltip>
          {userOrganizations && userOrganizations.length > 1 && (
            <Tooltip content={tooltipContent}>
              <Button variant="outline" disabled>
                {isLinkedOrParent ? "Manage linked teams" : "Link teams"}
              </Button>
            </Tooltip>
          )}
        </>
      ) : (
        <>
          <Button
            loading={customerPortalResponse.fetching}
            variant="outline"
            disabled={customerPortalResponse.fetching}
            onClick={() => fetchCustomerPortalQuery()}
          >
            View billing history
          </Button>
          <Button
            loading={paymentMethodUpdateResponse.fetching}
            variant="outline"
            disabled={paymentMethodUpdateResponse.fetching}
            onClick={() => fetchPaymentMethodUpdateQuery()}
          >
            Edit payment details
          </Button>
          {userOrganizations && userOrganizations.length > 1 && (
            <Button variant="outline" onClick={linkTeamsModal.open}>
              {isLinkedOrParent ? "Manage linked teams" : "Link teams"}
            </Button>
          )}
        </>
      )}
      <LinkTeamsModal
        isOpen={linkTeamsModalOpened}
        onClose={linkTeamsModal.close}
      />
    </Card>
  );
}

export default PaymentDetailsCard;
